// noinspection JSUnresolvedVariable
export default class User {
  jsonData?: unknown;

  constructor(
    public readonly id: number,
    public email: string,
    public firstName: string,
    public lastName: string,
    public admin?: boolean,
    public robot?: boolean,
    public autoUnsubscribed?: boolean,
    public subscribedToStatusEmails?: boolean,
    public createdAt?: string,
    public deletedAt?: string,
  ) {
    this.id = id;

    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;

    this.admin = admin;
    this.robot = robot;
    this.autoUnsubscribed = autoUnsubscribed;
    this.subscribedToStatusEmails = subscribedToStatusEmails;

    this.createdAt = createdAt;
    this.deletedAt = deletedAt;
  }
}
